import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1520. 見積タスク購読解除
 * [DELETE] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/quotation_tasks/:quotation_task_id/quotation_task_subscriptions/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  id: number;
};

const destroyQuotationTaskSubscription = (props: Props) => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/quotation_tasks/${props.task_id}/quotation_task_subscriptions/${props.id}`
  );
};

export const useDestroyQuotationTaskSubscription = () => {
  return useMutation({
    mutationFn: destroyQuotationTaskSubscription
  });
};